<template>
  <div class="page">
    <Header title="公告"></Header>
    <div v-html="noticeContent" class="notice-html notice-html-specInfo"></div>
  </div>
</template>

<script>
import homeApi from '@/api/home'
import Header from '@/components/header.vue'
export default {
  components: {
    Header
  },
  data () {
    return {
      noticeId: '',
      noticeInfo: null,
      noticeContent: ''
    }
  },
  created () {
    this.noticeId = this.$route.params.id || ''
    this.getNoticeInfo()
  },
  computed: {},
  methods: {
    getNoticeInfo () {
      homeApi.getNoticeInfo(this.noticeId).then(res => {
        if (res.data.resultCode === '0') {
          const { noticeInfo } = res.data.resultData
          this.noticeInfo = noticeInfo || null
          this.noticeContent = noticeInfo.noticeContent || ''
        }
      })
    }
  }
}
</script>
<style lang="less">
.notice-html {
  background-color: white;
  line-height: 2;
  font-size: 0.35rem;
  height: auto;

  p {
    width: 100% !important;
  }

  img {
    width: 100% !important;
  }
}

.notice-html-specInfo {
  padding: 0.25rem;
}
</style>
